export default {
	"tips.password.rules": "密码必须至少8个字符，包含大写字母、小写字母、数字和特殊字符。",
	"tips.contactUs": "请扫描下面的二维码通过微信联系我们的客服团队",
}
